<ng-template #modal let-close="close" let-dismiss="dismiss">
  <div class="modal-header">
    <h1 i18n class="modal-title">Accept ownership</h1>

    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="dismiss()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>

  <div class="modal-body" [formGroup]="form">
    <div class="form-group">
      <label i18n for="channel">Select a channel to receive the video</label>
      <my-select-channel labelForId="channel" formControlName="channel" [items]="videoChannels"></my-select-channel>

      <div *ngIf="formErrors.channel" class="form-error" role="alert">{{ formErrors.channel }}</div>
    </div>
  </div>

  <div class="modal-footer inputs">
    <div class="inputs">
      <input
        type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
        (click)="dismiss()" (key.enter)="dismiss()"
      >

      <input
        type="submit" i18n-value value="Accept" class="peertube-button orange-button"
        (click)="close()"
      >
    </div>
  </div>
</ng-template>
